import React, { useContext } from 'react';

import { If } from 'utils';
import { Config, UiKit } from 'components';
import { Provider, Actions, Helptext } from './components';
import { ShopperGroupSelectorContext } from './context';

export default function ShopperGroupSelector() {
  const {
    selectedOption,
    setSelectedOption,
    onChange,
    optionsList,
    isFetching,
    hasAccess,
    isConfigurable
  } = useContext(ShopperGroupSelectorContext);

  const changeHandler = option => {
    setSelectedOption(option);
    onChange(option);
  };

  return (
    <If test={hasAccess && isConfigurable}>
      <Config.Section description={<Helptext />}>
        <UiKit.Select
          label='Select "Global Settings" or a specific customer group to configure'
          options={optionsList}
          value={selectedOption}
          isLoading={isFetching}
          onChange={changeHandler}
        />
      </Config.Section>
      <Config.Separator />
    </If>
  );
}

ShopperGroupSelector.Provider = Provider;
ShopperGroupSelector.Context = ShopperGroupSelectorContext;
ShopperGroupSelector.Consumer = ShopperGroupSelectorContext.Consumer;
ShopperGroupSelector.Actions = Actions;
